import FormItem from "@components/FormItem/FormItem";
import FormSection from "@components/FormSection/FormSection";
import type { VesselNominationOutletContext } from "@features/vessel-nomination/add/constants";
import { FORM_FIELDS } from "@features/vessel-nomination/add/constants";
import type { VesselNominationFormData } from "@features/vessel-nomination/add/schema/vesselNominationFormSchema";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { LANG_BASE } from "../PreArrivalQuestionnaire";

const Tonnage = () => {
  const { t } = useTranslation();
  const { formData, updateFormData } = useOutletContext<VesselNominationOutletContext>();

  return (
    <FormProvider {...formData}>
      <FormSection
        title={t(`${LANG_BASE}.sections.tonnage`)}
        className="grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"
      >
        <div className="col-start-1 lg:col-start-1">
          <FormItem<VesselNominationFormData, typeof FORM_FIELDS.NET_TONNAGE>
            testId="nomination-net-tonnage-input"
            name={FORM_FIELDS.NET_TONNAGE}
            type="number"
            label={t(`${LANG_BASE}.fields.net-tonnage`)}
            onFieldChange={updateFormData}
            maxDigits={12}
            decimals={3}
            adornment="T"
            disabled
          />
        </div>
        <div className="col-start-1 lg:col-start-2">
          <FormItem<VesselNominationFormData, typeof FORM_FIELDS.GROSS_TONNAGE>
            testId="nomination-gross-tonnage-input"
            name={FORM_FIELDS.GROSS_TONNAGE}
            type="number"
            label={t(`${LANG_BASE}.fields.gross-tonnage`)}
            onFieldChange={updateFormData}
            maxDigits={12}
            decimals={3}
            adornment="T"
            disabled
          />
        </div>
      </FormSection>
    </FormProvider>
  );
};

export default Tonnage;
